export const getCurrentPath = () => {
    const arr = window.location.pathname.split('/');
    const baseUrl = arr.slice(0, -1).join('/');
    return `${baseUrl}`;
}